import { locales } from '@/i18n-config';

export const getPaths = (pathName: string) => {
  const paths = pathName.split('/').filter((path) => !!path);

  // if the dynamic [lang] value is present, remove the value from the array
  if (locales.includes(paths[0])) {
    paths.shift();
  }

  return {
    product: paths?.[0],
    partner: paths?.[1],
    presentation: paths?.[2],
    step: paths?.[3],
  };
};
